import React from 'react';
import "./Servicespage.scss";
import PageBanner from '../layouts/PageBanner';
import aboutServices from "../../assets/about-hero.jpg"; 
import ServicesShowcase from '../Servicespage/ServicesShowcase';
import ServiceDetail from './ServiceDetail';
const Servicespage = () => {
  return (
    <div className='avena-services-page'>
            <PageBanner
        title="Services"
        bg={aboutServices}
        crumbs={[
          { label: "Avena", href: "/" },
          { label: "Services" },
        ]}
      />

        <ServicesShowcase />
    </div>
  )
}

export default Servicespage
